var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.536 58.5355C129.488 56.5829 129.488 53.4171 127.536 51.4645C125.583 49.5118 122.417 49.5118 120.464 51.4645L127.536 58.5355ZM50 124C50 126.761 52.2386 129 55 129L100 129C102.761 129 105 126.761 105 124C105 121.239 102.761 119 100 119L60 119L60 79C60 76.2386 57.7614 74 55 74C52.2386 74 50 76.2386 50 79L50 124ZM120.464 51.4645L51.4645 120.464L58.5355 127.536L127.536 58.5355L120.464 51.4645Z",
    fill: "#0382BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 89,
    transform: "rotate(90 89.5 89.5)",
    stroke: "#0382BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowstand);
export default __webpack_public_path__ + "static/media/arrowstand.be0c9a0f5c0e5fea2be239d49a464889.svg";
export { ForwardRef as ReactComponent };